import type { DesktopAppId } from "./apps";
import { supportsMultipleWindows, windowId, type DesktopWindowState } from "./layout";
import { initialWindowBounds, type WorkArea } from "./windowGeometry";

export function activeWindowId(windows: DesktopWindowState[]) {
  const active = [...windows].filter((item) => !item.minimized).sort((a, b) => b.z - a.z)[0];
  return active ? windowId(active) : null;
}
export function focusWindow(windows: DesktopWindowState[], id: string, deskId?: string) {
  const z = Math.max(0, ...windows.map((item) => item.z)) + 1;
  return windows.map((item) => windowId(item) === id ? { ...item, ...(deskId ? { deskId } : {}), minimized: false, z } : item);
}
export function openOrFocus(windows: DesktopWindowState[], appId: DesktopAppId, area: WorkArea, deskId = "main", options: { newInstance?: boolean; navigationSearch?: string } = {}) {
  const multi = supportsMultipleWindows(appId);
  const existing = [...windows].sort((a, b) => b.z - a.z).find((item) => item.appId === appId && (!multi || (!options.newInstance && (item.deskId ?? "main") === deskId)));
  if (existing) return focusWindow(windows, windowId(existing), deskId).map((item) => windowId(item) === windowId(existing) && options.navigationSearch !== undefined ? { ...item, navigationSearch: options.navigationSearch } : item);
  if (windows.length >= 48) throw new Error("Limite de 48 janelas atingido. Feche uma janela antes de abrir outra.");
  return [...windows, {
    appId, ...(windows.some((item) => item.appId === appId) || options.newInstance ? { instanceId: crypto.randomUUID() } : {}),
    deskId, minimized: false, maximized: appId === "host-browser", bounds: initialWindowBounds(area, windows.length),
    navigationSearch: options.navigationSearch ?? "", z: Math.max(0, ...windows.map((item) => item.z)) + 1,
  }];
}
